import { Card, Flex, Text } from '@radix-ui/themes';
import PropTypes from 'prop-types';

export const StatsCard = ({
  title,
  value,
  icon,
  trend,
  color,
  style = {},
  className = '',
  onClick
}) => {
  return (
    <Card
      size="2"
      style={{
        transition: 'transform 0.2s ease, box-shadow 0.2s ease',
        cursor: 'pointer',
        ...style
      }}
      className={`stats-card ${className}`}
      onClick={onClick}
    >
      <Flex
        direction="row"
        justify="between"
        align="center"
      >
        <Flex direction="column" gap="1">
          <Text
            size="1"
            color="gray"
            weight="medium"
            style={{ textTransform: 'uppercase', letterSpacing: '0.5px' }}
          >
            {title}
          </Text>
          <Flex align="baseline" gap="2">
            <Text size="6" weight="bold">
              {value || '0'}
            </Text>
            {trend && (
              <Text
                size="2"
                color={trend.direction === 'up' ? 'green' : 'red'}
                weight="medium"
              >
                {trend.direction === 'up' ? '↑' : '↓'} {trend.value}%
              </Text>
            )}
          </Flex>
        </Flex>

        {icon && (
          <Flex
            align="center"
            justify="center"
            style={{
              backgroundColor: `var(--${color}-a3)`,
              color: `var(--${color}-a11)`,
              borderRadius: 'var(--radius-3)',
              padding: 'var(--space-1)',
              width: '32px',
              height: '32px',
            }}
          >
            {icon}
          </Flex>
        )}
      </Flex>
    </Card>
  );
};

StatsCard.propTypes = {
  title: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  icon: PropTypes.node,
  color: PropTypes.oneOf([
    'indigo', 'blue', 'green', 'red', 'orange',
    'purple', 'pink', 'yellow'
  ]),
  trend: PropTypes.shape({
    value: PropTypes.number,
    direction: PropTypes.oneOf(['up', 'down'])
  }),
  style: PropTypes.object,
  className: PropTypes.string
};

export default StatsCard; 